import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader.vue";
import AppFooter from "./layout/AppFooter.vue";
import Home from "./views/Home.vue";
import SignUp from "./views/SignUp.vue";
import Benefits from "./views/Benefits.vue";
import BenefitDetail from "./views/BenefitDetail.vue";
import Login from "./views/Login.vue";
import Record from "./views/Record.vue";
import Contact from "./views/Contact.vue";
import UpdateProfile from "./views/UpdateProfile.vue";
import FAQ from "./views/FAQ.vue";
import Complaint from "./views/Complaint.vue";



Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "Home",
      components: {
        header: AppHeader,
        default: Home,
        footer: AppFooter
      }
    },
    {
      path: "/login",
      name: "Login",
      components: {
        default: Login,
      }
    },
    {
      path: "/registro",
      name: "Registro",
      components: {
        header: AppHeader,
        default: SignUp,
        footer: AppFooter
      }
    },
    {
      path: "/historial-redenciones",
      name: "Record",
      components: {
        header: AppHeader,
        default: Record,
        footer: AppFooter
      }
    },
    {
      path: "/beneficios",
      name: "Beneficios",
      components: {
        header: AppHeader,
        default: Benefits,
        footer: AppFooter
      }
    },
    {
      path: "/FAQ",
      name: "FAQ",
      components: {
        header: AppHeader,
        default: FAQ,
        footer: AppFooter
      }
    },
    {
      path: "/beneficio/:slug",
      name: "Detalle",
      components: {
        header: AppHeader,
        default: BenefitDetail,
        footer: AppFooter
      }
    },
    {
      path: "/contacto",
      name: "Contacto",
      components: {
        header: AppHeader,
        default: Contact,
        footer: AppFooter
      }
    },
    {
      path: "/quejas/:id",
      name: "Quejas",
      components: {
        header: AppHeader,
        default: Complaint,
        footer: AppFooter
      }
    },
    {
      path: "/actualizar-perfil",
      name: "Actualizar Perfil",
      components: {
        header: AppHeader,
        default: UpdateProfile,
        footer: AppFooter
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
